import SetupDetails from "./SetupDetails";

export default SetupDetails;